import React from "react";
import { TabbedCodeExample } from "./TabbedCodeExample";

/**
 * `TranspiledCodeExample` is a component that renders a code example with a transpiler.
 * Useful for single-language code examples.
 *
 * Note that because it is based on `TabbedCodeExample`, this component modifies the language of the code based on the current app's language preference.
 * For example, if the current app is set to show JavaScript code, then the code example and the language label will be shown in JavaScript even if you specify "typescript" as the language.
 *
 * If you don't want this behaviour, use `CodeBlock` instead.
 */
export const TranspiledCodeExample = (props: {
  title?: React.ReactNode;
  /** A filename for the code contained in the codeblock */
  filename?: string;
  /** The code of the codeblock */
  children: string;
  /** What language to syntax highlight the code as */
  language: string;
  disableTranspiler?: boolean;
}) => {
  return (
    <TabbedCodeExample
      examples={{ [props.language]: props.children }}
      title={props.title}
      filename={props.filename}
      prettify
      disableTranspiler={props.disableTranspiler}
    />
  );
};
